import { type PropsWithChildren } from 'react';

export const Value = ({ children }: PropsWithChildren) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
);

Value['displayName'] = 'MeterBarChart.Value';
